import detectPlatform from "shared/detect_platform"

export class TrackComponentImpression {
  observer: IntersectionObserver | null = null
  container: HTMLElement

  constructor(container: HTMLElement) {
    this.container = container

    this.setupIntersectionObserver()
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const value = (entry.target as HTMLElement).dataset.trackImpression
          const serviceName = (entry.target as HTMLElement).dataset.serviceName
          const actionProperties = { platform: detectPlatform() }
          if (serviceName) {
            actionProperties["service_name"] = serviceName
          }

          if (value && value.length && window.App?.Utils?.logCustomDatadogAction) {
            window.App.Utils.logCustomDatadogAction(value, actionProperties)
          } else {
            console.error("data-track-impression attribute is empty")
          }

          this.observer?.unobserve(entry.target)
        }
      })
    })

    this.observer.observe(this.container)
  }
}

window.addEventListener("load", () => {
  const elements = document.querySelectorAll<HTMLElement>("[data-track-impression]")

  elements.forEach(container => {
    if (container) {
      new TrackComponentImpression(container)
    }
  })
})
